import { store } from '@/store/store';
import StorageHelper from '@/utils/storageHelper';
import { Account } from '@/services/Api/index';
import StaticContent from '@/services/Api/staticContents';
import { clearAppData } from '@/mixins/storageUtils.js';
import { extractErrorMessage } from '@/utils/errorExtractor';
import RoutesRoot from '@/router/routes/RoutesRoot.js';
import RoutesAthentication from '@/router/routes/RoutesAthentication.js';
import RoutesLogin from '@/router/routes/authentication/RoutesLogin.js';

const CONFIRM_MODAL_BASE = {
  isModalOpened: true,
  modalTitle: '',
  isDoubleButton: true,
  modalType: 'confirmation',
  firstButtonText: 'EVET',
  secondButtonText: 'HAYIR',
  modalConfirmationText: '',
  closeButton: false,
  closeOnOverlayClick: false,
};

const showError = error => {
  store.dispatch('auth/setLoginError', error);
  store.dispatch('app/setErrorModalConfig', {
    isModalOpened: true,
    modalText: extractErrorMessage(error),
  });
};

const openModal = config =>
  store.dispatch('app/setModalConfig', null).then(() => {
    store.dispatch('app/setModalConfig', config);
  });

const closeModal = () => store.dispatch('app/setModalConfig', {});

const setAuthDataFromStorage = ({ token, refreshToken, user, selectedPos }) => {
  if (token) {
    new StorageHelper({ id: process.env.VUE_APP_STORAGE_TOKEN_KEY }).set(token);
  }
  if (refreshToken && refreshToken.token) {
    new StorageHelper({ id: process.env.VUE_APP_STORAGE_REFRESH_TOKEN_KEY }).set(
      refreshToken.token,
    );
  }
  if (user) {
    new StorageHelper({ id: process.env.VUE_APP_STORAGE_CURRENT_USER_KEY }).set(user);
  }
  if (selectedPos) {
    new StorageHelper({ id: process.env.VUE_APP_STORAGE_CURRENT_POS_KEY }).set(selectedPos);
  }
};

const rejectAndLogout = () => {
  Account.validateStaff(false)
    .then(() => {
      closeModal();
      new StorageHelper({ id: process.env.VUE_APP_STORAGE_KACC_LOGOUT_INFO }).set(true);
      clearAppData(
        'logout',
        `${RoutesRoot.Authentication.path}/${RoutesAthentication.Login.path}/${RoutesLogin.SelectLoginType.path}`,
      );
    })
    .catch(showError);
};

const confirmStaffValidation = async () => {
  try {
    store.dispatch('auth/setLoginFetching', true);

    const res = await Account.validateStaff(true);
    const { Data } = res ? res.data : { Data: null };

    if (!Data) {
      return;
    }

    setAuthDataFromStorage(Data);
    closeModal();

    window.location.reload();
  } catch (error) {
    showError(error);
  } finally {
    store.dispatch('auth/setLoginFetching', false);
  }
};

function openRejectModal(channelContent) {
  openModal({
    ...CONFIRM_MODAL_BASE,
    modalText: channelContent ? channelContent.secondContent : '',
    firstButtonFn: rejectAndLogout,
    secondaryButtonFn: () => openConfirmModal(channelContent),
  });
}

function openConfirmModal(channelContent) {
  openModal({
    ...CONFIRM_MODAL_BASE,
    modalText: channelContent ? channelContent.content : '',
    firstButtonFn: confirmStaffValidation,
    secondaryButtonFn: () => openRejectModal(channelContent),
  });
}

export const startChangePosStaffValidation = async (posChannel, onBeforeModalOpen) => {
  new StorageHelper({ id: process.env.VUE_APP_STORAGE_USER_ACCOUNT_TYPE }).set(posChannel);

  let channelContent = null;

  try {
    const res = await StaticContent.getChannelContent();
    channelContent = res && res.data ? res.data.Data : null;
  } catch (error) {
    showError(error);
    return;
  }

  if (typeof onBeforeModalOpen === 'function') {
    onBeforeModalOpen();
  }

  openConfirmModal(channelContent);
};
